// src/components/BannerBottom.jsx
import React from "react";

const BannerBottom = () => {
  return (
    <div className="w-full bg-gray-100 py-3">
      <p className="text-center text-gray-800 font-semibold text-lg">
        Welcome to BCC Mart – Your One-Stop Hypermarket for All Your Needs!
      </p>
    </div>
  );
};

export default BannerBottom;